import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor (
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService.populate();
  }

  onDeactivate() {
    document.body.scrollTop = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts